import React, { useState } from 'react';

import { useSnrwbCore } from '../../../../common/hooks/useSnrwbCore';
import { ReportInspectedProductsBySignType } from '../../../../common/types/ReportTypes';
import { ReportInspectedProductsBySign } from '../../../components/ReportInspectedProducts/ReportInspectedProductsBySign';
import { Filter, FilterReportData } from '../../../components/Reports/Filter';

export const ReportInspectedProductsBySignView: React.FC = () => {
  const snrwbApi = useSnrwbCore();
  const [filterApplied, setFilterApplied] = useState(false);
  const [usedFilter, setUsedFilter] = useState<FilterReportData | undefined>(
    {},
  );
  const [data, setData] = useState<ReportInspectedProductsBySignType>({
    details: {},
    sum: {},
  });

  const onSearch = (filter?: FilterReportData) => {
    setFilterApplied(true);
    setUsedFilter(filter);
    snrwbApi.reports.reportProductsBySign(true, filter).then(dataReports => {
      setData(dataReports);
    });
  };

  return (
    <>
      <Filter
        onSearch={onSearch}
        reportName="Skontrolowane wyroby wg oznakowania"
      />
      <ReportInspectedProductsBySign
        data={data}
        reportName="Skontrolowane wyroby wg oznakowania"
        filterApplied={filterApplied}
        usedFilter={usedFilter}
      />
    </>
  );
};
